<nav class="mobile-bottom-nav lg:!hidden !flex" aria-label="Primary">
  @for (item of visibleItems; track item.label) {
    <!-- `routerLink` is bound as a string, not `[item.link]`: an array literal
         is a new reference on every check and trips NG0100 in development. -->
    <a
      class="mobile-bottom-nav__item"
      [routerLink]="item.link"
      routerLinkActive="is-active"
      ariaCurrentWhenActive="page"
      (click)="onItemClick(item)"
    >
      <i class="mobile-bottom-nav__icon" [sch-icon]="item.icon" aria-hidden="true"></i>
      <span class="mobile-bottom-nav__label">{{ item.label }}</span>
    </a>
  }

  @for (item of pinnedItems; track item.label) {
    <button
      type="button"
      class="mobile-bottom-nav__item"
      [attr.aria-label]="item.label"
      (click)="onItemClick(item)"
    >
      <i class="mobile-bottom-nav__icon" [sch-icon]="item.icon" aria-hidden="true"></i>
      <span class="mobile-bottom-nav__label">{{ item.label }}</span>
    </button>
  }
</nav>
